export const STORE_INFO = {
  name: 'Lounge華',
  nameEn: 'LOUNGE HANA',
  tagline: '大人の時間が、静かに流れる場所',
  taglineEn: 'A place where time flows quietly for adults',
  address: '富山市総曲輪1丁目2-20 センタービル3階',
  tel: '080-3749-3463',
  telHref: 'tel:08037493463',
  instagram: 'https://www.instagram.com/lounge_hana0915/',
  instagramDm: 'https://ig.me/m/lounge_hana0915',
  hours: '20:00～ラスト ※お問い合わせください。',
  closed: '日曜日（変更あり）',
  since: '2024',
  paymentMethods: '現金 / カード / QR決済 ※インボイス対応',
  tax: '10%',
  serviceCharge: '10%',
  cardFee: '無料',
  electronicPaymentFee: '無料',
  mapEmbedUrl:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3196.0!2d137.2113!3d36.6953!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5ff7959b5e5e5e5e%3A0x0!2z5a6H5bGx5biC5YCJ5pys6Iiq77yR5LiB55uu77yS4oiS77yS77yQ!5e0!3m2!1sja!2sjp!4v1700000000000',
};

export const CONCEPT_TEXT = {
  label: 'Our Concept',
  heading: '私たちのこだわり',
  body: [
    '「Lounge華」は、富山の夜に静かな彩りを添える大人のための空間です。',
    '日々の喧騒を忘れ、ゆったりとした時間の中で、心ほぐれるひとときをお過ごしください。',
    '丁寧に選んだお酒と、温かみのある会話。特別な夜のはじまりを、ここから。',
  ],
  mamaSays: {
    label: 'Mama\'s Message',
    text: '「お客様おひとりおひとりに、居心地のよい時間を。\n気取らず、でも品よく。そんな場所でありたいと思っています。」',
    name: '— ママ より',
  },
};

export const VIRTUAL_TOUR = {
  label: 'Virtual Tour',
  heading: '店内を見渡す',
  description: '指やマウスで店内をぐるりと見渡せます。矢印をタップすると、別の視点へ移動できます。',
  hint: 'ドラッグして見渡す',
  note: '※ 金色の矢印をタップすると、ソファ席とバーカウンターを行き来できます。',
  scenes: {
    lounge: 'ソファ席',
    bar: 'バーカウンター',
  },
};

export const PRICING_ITEMS = [
  {
    icon: 'ri-cup-line',
    name: '飲み放題',
    price: '',
    unit: '',
    desc: '',
    priceLines: [
      { label: '女性', price: '¥3,500', unit: '/ 60分' },
      { label: '男性', price: '¥4,000', unit: '/ 60分' },
    ],
  },
  {
    icon: 'ri-goblet-line',
    name: 'ボトルセット',
    price: '¥5,000〜',
    unit: '/ 1時間40分',
    desc: 'ボトルとセットでお楽しみいただけるプランです。',
  },
  {
    icon: 'ri-flask-line',
    name: 'ボトルキープ',
    price: '¥4,000〜',
    unit: '',
    desc: '焼酎・ウイスキー・ブランデー等、各種ご用意しております。',
  },
  {
    icon: 'ri-beer-line',
    name: 'ドリンク単品',
    price: '¥1,000〜',
    unit: '',
    desc: 'カクテル・ビール・ソフトドリンクなど豊富にご用意しています。',
  },
  {
    icon: 'ri-door-open-line',
    name: '貸切個室',
    price: 'あり',
    unit: '',
    desc: 'プライベートな空間でのご利用も可能です。詳細はお問い合わせください。',
  },
];

export const SISTER_STORES = [
  {
    name: 'Uru',
    nameEn: 'URU',
    genre: 'Girls Bar',
    genreJa: 'ガールズバー',
    concept: 'クール＆セクシーな空間で、特別な夜を。',
    address: '富山市総曲輪1丁目3-9 グリーンビル2F',
    target: '20〜30代前半',
    instagram: 'https://www.instagram.com/uru_sakuragi/',
    url: 'https://girlsbar-uru.pages.dev/',
    recruitNote: 'スタッフ募集中',
    accentColor: '#7B9EA8',
    image: 'https://readdy.ai/api/search-image?query=cool%20sexy%20girls%20bar%20interior%20dark%20moody%20atmosphere%20neon%20blue%20teal%20accent%20lighting%20sleek%20modern%20Japanese%20night%20bar%20stylish%20counter%20young%20vibrant%20Toyama&width=800&height=600&seq=uru001&orientation=landscape',
  },
  {
    name: '\uD835\uDC9C\uD835\uDC52\uD835\uDC51\uD835\uDC52\uD835\uDC59',
    nameDisplay: 'Aedel',
    nameEn: 'AEDEL',
    subName: '\u30A8\u30FC\u30C7\u30EB',
    genre: 'Mix Bar',
    genreJa: 'MIXバー',
    concept: 'かっこいい夜を、みんなで。心が弾む空間。',
    address: '富山県富山市総曲輪1丁目2-20 桜木町センタービル3階',
    target: '20〜30代前半',
    instagram: 'https://www.instagram.com/aedel2024.07.12/',
    url: 'https://bar-aedel.pages.dev/',
    recruitNote: '',
    accentColor: '#C9A84C',
    image: 'https://readdy.ai/api/search-image?query=trendy%20mix%20bar%20interior%20dark%20vibrant%20party%20atmosphere%20colorful%20neon%20lights%20modern%20Japanese%20night%20club%20stylish%20young%20crowd%20energetic%20Toyama%20cool%20design&width=800&height=600&seq=aedel001&orientation=landscape',
  },
];
